// src/errors/ServerError.tsx

import ErrorPage from "./ErrorPage";

export default function ServerError() {
    return (
        <ErrorPage
            variant="server"
            statusLabel="System status"
            statusCode={500}
            title="Server Error"
            message="Something went wrong on our end. Please try again later."
            actionLabel="Go to Dashboard"
            redirectTo="/"
            secondaryActionLabel="Try Again"
            secondaryActionType="reload"
            helperText="Your data is safe. This appears to be a temporary service issue."
            showSupport
        />
    );
}